<template>
  <div class="my-editor">
    <toolbar v-if="showToolbar" class="toolbar" :editor="editor" :default-config="toolbarConfig" />
    <editor v-model="htmlValue" class="editor-wrapper" :default-config="editorConfig" @onCreated="onCreated" @onChange="onChange" />
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'

export default {
  name: 'MyEditor',
  emits: ['change'],
  components: { Editor, Toolbar },
  props: {
    value: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    images: {
      type: Array,
      default: () => []
    },
    notExists: {
      type: Array,
      default: () => []
    },
    autoFocus: Boolean,
    showToolbar: {
      type: Boolean,
      default: true
    },
    videos: {
      type: Array,
      default: () => []
    },
    readOnly: Boolean
  },
  data() {
    return {
      imageList: [],
      videoList: [],
      htmlValue: '',
      editor: null,
      toolbarConfig: {
        excludeKeys: ['blockquote', 'headerSelect', 'fontFamily', 'emotion', 'group-more-style', 'todo', 'insertLink', 'divider', 'insertTable', 'codeBlock']
      },
      editorConfig: {
        placeholder: '请输入内容...',
        autoFocus: this.autoFocus,
        readOnly: this.readOnly,
        MENU_CONF: {
          color: {
              colors: [
                '#000000', '#444444', '#666666', '#999999',
                '#cccccc', '#eeeeee', '#f3f3f3', '#ffffff',
                '#ff0000', '#ff9900', '#ffff00', '#00ff00',
                '#00ffff', '#0000ff', '#ff00ff', '#800000',
                '#8b4513', '#ffa500', '#808000', '#008000',
                '#008080', '#000080', '#800080', '#808080',
                '#c0c0c0', '#ff6347', '#ffd700', '#adff2f',
                '#00ced1', '#1e90ff', '#dda0dd', '#f5deb3'
              ]
          },
          bgColor: {
              colors: [
                '#000000', '#444444', '#666666', '#999999',
                '#cccccc', '#eeeeee', '#f3f3f3', '#ffffff',
                '#ff0000', '#ff9900', '#ffff00', '#00ff00',
                '#00ffff', '#0000ff', '#ff00ff', '#800000',
                '#8b4513', '#ffa500', '#808000', '#008000',
                '#008080', '#000080', '#800080', '#808080',
                '#c0c0c0', '#ff6347', '#ffd700', '#adff2f',
                '#00ced1', '#1e90ff', '#dda0dd', '#f5deb3'
              ]
          },
          fontSize: {
            fontSizeList: ['12px', '13px', '14px', '15px', '16px', '17px', '18px', '20px']
          },
          lineHeight: {
            lineHeightList: ['1', '1.5', '2', '2.5', '3']
          },
          uploadImage: {
            fieldName: 'file',
            // 单个文件的最大体积限制，默认为 2M，设置为5M
            maxFileSize: 5 * 1024 * 1024,
            // 500K 以下插入 base64
            // base64LimitSize: 500 * 1024,
            customUpload: (file, insertFn) => {
              const data = new FormData()
              data.append('file', file)
              data.append('name', file.name)
              data.append('fileSize', file.size)
              data.append('fileType', file.type)
              const imgUrl = URL.createObjectURL(file)

              this.imageList.push({ url: imgUrl, old: imgUrl, file: data })
              insertFn(imgUrl)
            }
          },
          uploadVideo: {
            fieldName: 'file',
            // 单个文件的最大体积限制，默认为 10M，设置为30M
            maxFileSize: 30 * 1024 * 1024,
            customUpload: (file, insertFn) => {
              const data = new FormData()
              data.append('file', file)
              data.append('name', file.name)
              data.append('fileSize', file.size)
              data.append('fileType', file.type)
              const videoUrl = URL.createObjectURL(file)

              this.videoList.push({ url: videoUrl, old: videoUrl, file: data })
              insertFn(videoUrl)
            }
          }
        }
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.htmlValue = newValue
      }
    },
    images: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.imageList = [...newValue]
      }
    },
    videos: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.videoList = [...newValue]
      }
    }
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor === null) return
    editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
    },
    onChange(editor) {
      const notExists = []
      const content = editor.getHtml()
      const images = editor.getElemsByType('image')
      this.imageList.forEach(item => {
        const index = images.findIndex(img => img.src === item.url)
        if (index < 0) notExists.push(item)
      })
      const videos = editor.getElemsByType('video')
      this.videoList.forEach(item => {
        const index = videos.findIndex(video => video.src === item.url)
        if (index < 0) notExists.push(item)
      })

      // notExists.forEach(item => {
      //   const index = this.imageList.findIndex(img => img.url === item.url)
      //   this.imageList.splice(index, 1)
      // })
      this.$emit('update:text', this.getText(content))
      // this.$emit('update:text', editor.getText())
      this.$emit('update:images', this.imageList)
      this.$emit('update:videos', this.videoList)
      this.$emit('update:notExists', notExists)
      this.$emit('input', content)
      this.$emit('change')
    },
    getText(content) {
      // 1、将所有<p>标签 replace ''
      // 2、将所有</p>标签 replace ''
      // 3、将所有 空格 replace ''
      // 4、将所有 换行符 replace ''
      return content.replace(/<[^<p>]+>/g, '').replace(/<[</p>$]+>/g, '').replace(/&nbsp;/gi, '').replace(/<[^<br/>]+>/g, '')
    },
    isEmpty(content) {
      if (content === undefined || content === null) return true

      const text = this.getText(content)
      if (text === '') return true
      // const content = this.editor.getText()
      // if (!content) return true

      const regExp = new RegExp('^[ ]+$')
      return regExp.test(text)
    }
  }
}
</script>

<style lang="scss" scoped>
$editorMinHeight: 500px;

.my-editor {
  position: relative;
  display: block;
  flex: 1;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #c0ccda;
  .toolbar {
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid #c0ccda;
    ::v-deep {
      .w-e-toolbar {
        border-radius: inherit;
      }
    }
  }
  .editor-wrapper {
    height: $editorMinHeight;
    border-radius: 0 0 4px 4px;
    ::v-deep {
      .w-e-text-container {
        border-radius: inherit;
        .w-e-scroll {
          min-height: $editorMinHeight;
          [data-slate-editor] {
            min-height: $editorMinHeight;
            p {
              margin: 10px 0;
              max-width: 750px;
              .w-e-image-container {
                margin: 0;
                font-size: 0;
              }
            }
          }
        }
        .w-e-text-placeholder {
          top: 3px;
        }
        .w-e-modal {
          border: 1px solid var(--w-e-toolbar-border-color);
          padding: 38px 15px 0;
          .babel-container {
            display: flex;
            align-items: center;
            margin-bottom: 11px;
            span {
              margin: initial;
              margin-right: 10px;
            }
            input {
              flex: 1;
            }
          }
          .button-container {
            margin: 15px 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
        }
      }
    }
  }
}
</style>
